// extracted by mini-css-extract-plugin
module.exports = {"card-wrapper":"styles_card-wrapper__fBpsD","card":"styles_card___7sNO"};